import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Image, Spinner } from 'react-bootstrap';
import sectionApi from '../../services/sectionapi'; // Assuming you have one API files
import brandAPI from '../../services/brandapi';
import categoryAPI from '../../services/category';
import Select from 'react-select';
// import './SectionList.css';
import productAPI from '../../services/productapi';

function EditItemModal({ show, onClose, item, onSave, saving }) {
    // console.log(item, 'item');
    const [formData, setFormData] = useState({
        title: '',
        slug: '',
        url: '',
        files: null,
        preview: null,
        actionIdType: 1,
        actionID: '',
        id: '',
        homesecListID: '',
        status: 1
    });

    const [options, setOptions] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [loadingOptions, setLoadingOptions] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);

    useEffect(() => {
        if (item) {
            setFormData({
                title: item.title || '',
                slug: item.slug || '',
                url: item.url || '',
                files: null,
                preview: item.valueData ? `${process.env.REACT_APP_IMAGE_URL}${item.valueData}` : null,
                actionIdType: item.actionIdType || 1,
                actionID: item.actionID || '',
                id: item.id || null,
                homesecListID: item.homesecListID || item.home_sec_list_id || item.homeSecListId || '',
                status: item.status || 1
            });
        }
    }, [item]);

    useEffect(() => {
        if (searchText.trim().length > 1) {
            fetchOptions(formData.actionIdType, searchText);
        }
    }, [formData.actionIdType, searchText]);

    const fetchOptions = async (type, query) => {
        setLoadingOptions(true);
        try {
            let response = null;
            let filterModel = {
                quickFilterValues: [query]
            };
            // console.log(filterModel, 'filterModel');

            switch (parseInt(type)) {
                case 1:
                    let resp = await productAPI.getAllProductItems({ limit: 150, page: 0, status: 1, filterModel });
                    if (resp.status === 'SUCCESS') {
                        // Create response object and assign data if successful
                        response = {
                            status: 'SUCCESS',
                            data: resp.data.result || [] // Ensure to handle any undefined or missing data
                        };
                    } else {
                        response = { success: false, data: [] };
                    }
                    break;

                case 2:
                    response = await categoryAPI.getAllCategory(40, 0, query);
                    break;

                case 3:
                    let respb = await brandAPI.getAllBrands({ limit: 40, page: 0, query });
                    if (respb.status === 'SUCCESS') {
                        response = {
                            status: 'SUCCESS',
                            data: respb.data.result || [] // Ensure to handle any undefined or missing data
                        };
                    } else {
                        response = { success: false, data: [] };
                    }
                    break;

                default:
                    return;
            }

            // console.log(response, 'response');
            if (response && response.status === 'SUCCESS') {
                setOptions(response.data);
            } else {
                setOptions([]); // In case the response doesn't have status or data is empty
            }
        } catch (error) {
            console.error('Error fetching options:', error);
        } finally {
            setLoadingOptions(false);
        }
    };


    // console.log(options, 'Options');
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setFormData(prev => ({
            ...prev,
            files: file,
            preview: file ? URL.createObjectURL(file) : prev.preview
        }));
    };

    const handleSubmit = (e) => {
        if (!formData) {
            return null; // Prevent rendering if formData is not available
        }
        e.preventDefault();
        onSave(formData);
        // onClose();
    };

    const capitalizeWords = (text) => {
        if (!text) return '';
        return text
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };
    // console.log(formData, 'form Data');
    return (
        <Modal show={show} onHide={onClose} centered className='editModel' >
            <Modal.Header closeButton>
                <Modal.Title>Edit Item</Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>

                    <Form.Group className="mb-3">
                        <Form.Label>Title</Form.Label>
                        <Form.Control name="title" value={formData.title} onChange={handleChange} />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Slug</Form.Label>
                        <Form.Control name="slug" value={formData.slug} onChange={handleChange} />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>URL</Form.Label>
                        <Form.Control name="url" value={formData.url} onChange={handleChange} />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Image</Form.Label>
                        <Form.Control type="file" onChange={handleFileChange} />
                        {formData.preview && (
                            <Image src={formData.preview} alt="Preview" fluid className="mt-2" />
                        )}
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Action Type</Form.Label>
                        <Form.Select
                            name="actionIdType"
                            value={formData.actionIdType}
                            onChange={(e) => {
                                handleChange(e);
                                setOptions([]); // Clear options when type changes
                                setSearchText('');
                            }}
                        >
                            <option value={0}>None</option>
                            <option value={1}>Product</option>
                            <option value={2}>Category</option>
                            <option value={3}>Brand</option>
                            <option value={4}>Offers Page</option>
                        </Form.Select>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Search & Select Item</Form.Label>
                        <Select
                            placeholder="Search..."
                            isClearable
                            isLoading={loadingOptions}
                            value={selectedOption}
                            onInputChange={(inputValue, { action }) => {
                                if (action === 'input-change') {
                                    setSearchText(inputValue);
                                }
                            }}
                            onChange={(selected) => {
                                setSelectedOption(selected);
                                // console.log(selected, 'selected');
                                if (selected) {
                                    const rawSlug = selected.slug || selected.label;
                                    const slugified = rawSlug?.toLowerCase().replace(/\s+/g, '-');
                                    let urlPrefix = '';

                                    switch (parseInt(formData.actionIdType)) {
                                        case 1: urlPrefix = 'pd/'; break;
                                        case 2: urlPrefix = 'ct/'; break;
                                        case 3: urlPrefix = 'bd/'; break;
                                        default: urlPrefix = '';
                                    }

                                    setFormData(prev => ({
                                        ...prev,
                                        actionID: selected.id,
                                        slug: slugified,
                                        url: urlPrefix + slugified,
                                    }));

                                } else {
                                    setFormData(prev => ({
                                        ...prev,
                                        actionID: '',
                                        slug: '',
                                        url: ''
                                    }));
                                }
                            }}

                            options={options.map(opt => ({
                                id: opt.id || opt.categoryID || opt.productId,
                                label: capitalizeWords(opt.name || opt.productName || opt.categoryName),
                                value: opt.id || opt.categoryID,
                                slug: opt.slug || opt.name || opt.productName || opt.categoryName
                            }))}
                            styles={{ menu: base => ({ ...base, zIndex: 9999 }) }}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>Status</Form.Label>
                        <Form.Select
                            name="status"
                            value={formData.status}
                            onChange={handleChange}
                        >
                            <option value={1}>Active</option>
                            <option value={2}>Inactive</option>
                        </Form.Select>
                    </Form.Group>



                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={onClose}>Cancel</Button>
                    <Button type="submit" variant="primary" disabled={saving}>
                        {saving ? <Spinner animation="border" size="sm" /> : 'Save'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

export default EditItemModal;
